import request from '@/utils/request'
export function mallWidget(data) {
  return request({
    url: "/api/mall/widget",
    method: 'post',
    data
  })
}
export function memberPay(data) {
  return request({
    url: "/api/member/pay",
    method: 'post',
    data
  })
}
export function codeNtoken(data) {
  return request({
    url: "/api/hx/mobile/code/ntoken",
    method: 'post',
    data
  })
} export function loginMobileCheck(data) {
  return request({
    url: "/api/login/mobile/check",
    method: 'post',
    data
  })
}
// ---------------------影院接口 ------------------------
// 卡券绑定前状态查询
export function cardCheckNtoken(data) {
  return request({
    url: "/api/member/card/check/ntoken",
    method: 'post',
    data
  })
}
//  获取适用门店
export function cardSupplier(data) {
  return request({
    url: "/api/mall/card/supplier/b",
    method: 'post',
    data
  })
}
// 定位
export function movieCityList(data) {
  return request({
    url: "api/qmm/city/list",
    method: 'post',
    data
  })
}
// 获取区级影院 ?
export function cinemaDistancePrice(data) {
  return request({
    url: "api/zjdy/cinema/distance/price",
    method: 'post',
    data
  })
}
// 获取区级
export function districtList(data) {
  return request({
    url: "api/zjdy/district/list",
    method: 'post',
    data
  })
}
// 影片详情
export function movieGetWait(data) {
  return request({
    url: "api/zjdy/movie/get/wait",
    method: 'post',
    data
  })
}
// 影片详情
export function movieGet(data) {
  return request({
    url: "api/zjdy/movie/get",
    method: 'post',
    data
  })
}
// 摧毁订单
export function orderCancel(data) {
  return request({
    url: "api/zjdy/seat/cancel",
    method: 'post',
    data
  })
}
// 创建订单
export function orderCreate(data) {
  return request({
    url: "api/zjdy/seat/lock",
    method: 'post',
    data
  })
}
// 电影选座
export function movieSeat(data) {
  return request({
    url: "api/zjdy/movie/seat",
    method: 'post',
    data
  })
}
// 影院排期价格
export function movieHot(data) {
  return request({
    url: "api/zjdy/movie/list",  
    method: 'post',
    data
  })
}
// 影院排期价格
export function moviePrice(data) {
  return request({
    url: "api/zjdy/movie/show",
    method: 'post',
    data
  })
}
// 影院排期
export function moviePlaydate(data) {
  return request({
    url: "api/zjdy/movie/show",
    method: 'post',
    data
  })
}
// 正在上映
export function movieNow(data) {
  return request({
    url: "api/zjdy/movie/now",
    method: 'post',
    data
  })
}
// 即将上映
export function movieSoon(data) {
  return request({
    url: "api/zjdy/movie/soon",
    method: 'post',
    data
  })
}
// 所有影院
export function cimeraDistance(data) {
  return request({

    url: "api/zjdy/cinema/distance",
    method: 'post',
    data
  })
}

// 影院详情
export function cinemaGet(data) {
  return request({

    url: "api/zjdy/cinema/get",
    method: 'post',
    data
  })
}
// ---------------------- 商城接口 -------------------
  //  商城信息
export function mallInfo(data) {
    return request({
      url: "/mall/info",
      method: 'post',
      data
    })
  }
//  电影定价  选影院的时候改价
export function priceChange(data) {
  return request({
    url: "api/zjdy/price/change",
    method: 'post',
    data
  })
}

//  获取卡券列表信息
export function cardList(data) {
  return request({
    url: "api/film/card/list",
    method: 'post',
    data
  })
}
//  取消锁票
export function pay(data) {
  return request({
    url: "api/zjdy/pay",
    method: 'post',
    data
  })
}

//  新增卡券
export function cardBind(data) {
  return request({
    url: "api/member/card/bind",
    method: 'post',
    data
  })
}

// 计算实付钱数
export function cardUse(data) {
  return request({
    url: "api/zjdy/card/use",
    method: 'post',
    data
  })
}